import { Brand } from '@/models/Brand';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component<BrandAutocomplete>({})
export default class BrandAutocomplete extends Vue {

  // #region @VModel
  // #endregion

  // #region @PropSyncs
  // #endregion

  // #region @Props

  @Prop({ default: 'Brand' })
  protected label!: string;

  @Prop({ default: () => new Brand() })
  protected model!: Brand;

  @Prop({ default: 'Choose a brand' })
  protected placeholder!: string;

  // #endregion

  // #region @Refs
  // #endregion

  // #region Props
  // #endregion

  // #region Plugin props
  // #endregion

  // #region Lifecycle hooks / Init
  // #endregion

  // #region Handlers
  // #endregion

  // #region Helpers
  // #endregion

  // #region API Requests
  // #endregion

  // #region Getters & Setters
  // #endregion

  // #region @Watchers
  // #endregion
}
